import { useTranslation } from "react-i18next";

import styles from "./StatusDot.module.scss";

interface StatusDotProps {
  color: string;
  label?: string;
}

const StatusDot = ({ color, label }: StatusDotProps) => {
  const { t } = useTranslation();

  return (
    <span className={styles.status}>
      <span className={styles.status__dot} style={{ backgroundColor: color }} />
      {label && (
        <span className={styles.status__label} style={{ color }}>
          {t(label)}
        </span>
      )}
    </span>
  );
};

export default StatusDot;
